var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    [
      _c("template", { slot: "title" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Informations Générales")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "div",
            {
              class: _vm.mainClasses,
              attrs: { "data-bot": "overview__general-info" }
            },
            [
              _c("section", { staticClass: "flex" }, [
                _c("h3", {
                  staticClass: "m-3 flex-row baseline",
                  domProps: { innerHTML: _vm._s(_vm.isCorporationLabel) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "px-3 br-1" }, [
                  _c("div", [
                    _c("h4", { staticClass: "m-0" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Générales")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "my-2" },
                      _vm._l(_vm.removeInvalidValue(_vm.general), function(
                        item,
                        indexItem
                      ) {
                        return _c(
                          "li",
                          {
                            key: indexItem,
                            staticClass: "data-block data-block-hover"
                          },
                          [
                            _c(
                              item.format + "-data",
                              _vm._b(
                                {
                                  tag: "component",
                                  attrs: {
                                    useFavorite: !!item.favoriteName,
                                    list: _vm.favorites
                                  },
                                  on: {
                                    toggleFavorite: function($event) {
                                      return _vm.updateFavorites(item)
                                    }
                                  }
                                },
                                "component",
                                item,
                                false
                              )
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _vm.mainContact && _vm.identity.isCorporation
                    ? _c("div", { staticClass: "mt-4" }, [
                        _c("h4", { staticClass: "m-0" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Contact principal")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "my-2" },
                          _vm._l(
                            _vm.removeInvalidValue(_vm.mainContact),
                            function(item, indexItem) {
                              return _c(
                                "li",
                                {
                                  key: indexItem,
                                  staticClass: "data-block data-block-hover"
                                },
                                [
                                  _c(
                                    item.format + "-data",
                                    _vm._b(
                                      {
                                        tag: "component",
                                        attrs: {
                                          useFavorite: !!item.favoriteName,
                                          list: _vm.favorites
                                        },
                                        on: {
                                          toggleFavorite: function($event) {
                                            return _vm.updateFavorites(item)
                                          }
                                        }
                                      },
                                      "component",
                                      item,
                                      false
                                    )
                                  )
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "flex" }, [
                _c("h3", { staticClass: "m-3 flex-row baseline" }, [
                  _c(
                    "span",
                    { staticClass: "flex-right" },
                    [
                      _c(
                        "CompassTooltip",
                        {
                          attrs: {
                            disabled: _vm.canEdit,
                            placement: "bottom-end",
                            content: _vm.$t.__(
                              "common.labels.no_permissions_to_perform_this_action"
                            )
                          }
                        },
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__(
                                "overview.tabs.TabInformationsThird.edit"
                              ),
                              type: "tertiary",
                              disabled: !_vm.canEdit,
                              "data-bot": _vm.databot["generalinfoedit1"]
                            },
                            on: { click: _vm.edit }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "px-3" }, [
                  _vm.removeRateCategoryForSupplier(_vm.financial).length > 0
                    ? _c("div", [
                        _c("h4", { staticClass: "m-0" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Données comptables")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "my-2" },
                          _vm._l(
                            _vm.removeRateCategoryForSupplier(_vm.financial),
                            function(item, indexItem) {
                              return _c(
                                "li",
                                {
                                  key: indexItem,
                                  staticClass: "data-block data-block-hover"
                                },
                                [
                                  _c(
                                    item.format + "-data",
                                    _vm._b(
                                      {
                                        tag: "component",
                                        attrs: {
                                          useFavorite: !!item.favoriteName,
                                          list: _vm.favorites
                                        },
                                        on: {
                                          toggleFavorite: function($event) {
                                            return _vm.updateFavorites(item)
                                          }
                                        }
                                      },
                                      "component",
                                      item,
                                      false
                                    )
                                  )
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.removeInvalidValue(_vm.legal).length > 0 &&
                  _vm.identity.isCorporation
                    ? _c("div", { staticClass: "mt-4" }, [
                        _c("h4", { staticClass: "m-0" }, [
                          _vm._v(
                            _vm._s(_vm.$l10n.__("Informations juridiques"))
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "my-2" },
                          _vm._l(_vm.removeInvalidValue(_vm.legal), function(
                            item,
                            indexItem
                          ) {
                            return _c(
                              "li",
                              {
                                key: indexItem,
                                staticClass: "data-block data-block-hover"
                              },
                              [
                                _c(
                                  item.format + "-data",
                                  _vm._b(
                                    {
                                      tag: "component",
                                      attrs: {
                                        useFavorite: true,
                                        list: _vm.favorites
                                      },
                                      on: {
                                        toggleFavorite: function($event) {
                                          return _vm.updateFavorites(item)
                                        }
                                      }
                                    },
                                    "component",
                                    item,
                                    false
                                  )
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("sellsy-informations-section", {
                attrs: {
                  linkedid: _vm.$store.getters.linkedid,
                  linkedtype: _vm.$store.getters.linkedtype,
                  enableTags: true,
                  data: _vm.$store.getters.sellsyInformations,
                  canDisplayMassMailingConsent: _vm.canDisplayMassMailingConsent
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.canDisplayMarketingConsent
            ? _c("MarketingConsentOverview")
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }